// import React, { useState, useRef, useEffect } from "react";
// import {
//   ArrowLeft,
//   ArrowRight,
//   ZoomIn,
//   ZoomOut,
//   Maximize2,
//   Sparkles,
//   Zap,
//   Sun,
//   Moon,
// } from "lucide-react";

// const ImageDisplay = ({
//   isSidebarCollapsed,
//   selectedImage,
//   imageUrl,
//   setImageUrl,
//   isImageLoading,
//   isHighRes,
//   setIsHighRes,
//   filteredImages,
//   currentImageIndex,
//   loadImage,
//   showNotification,
//   isListLoading,
//   onNavigatePrevious,
//   onNavigateNext,
// }) => {
//   const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
//   const [scale, setScale] = useState(1);
//   const [position, setPosition] = useState({ x: 0, y: 0 });
//   const [isDragging, setIsDragging] = useState(false);
//   const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
//   const [brightness, setBrightness] = useState(100);

//   const imageRef = useRef(null);
//   const containerRef = useRef(null);


// // Reset zoom, position, and brightness when image URL changes
// useEffect(() => {
//   setScale(1);
//   setPosition({ x: 0, y: 0 });
//   setBrightness(100);
// }, [imageUrl]);

//   const handleImageLoad = (e) => {
//     const img = e.target;
//     setImageSize({
//       width: img.naturalWidth,
//       height: img.naturalHeight,
//     });
//     console.log("Image loaded successfully:", img.naturalWidth, "x", img.naturalHeight);
//   };

//   const handleImageError = (e) => {
//     console.error("Image failed to load in <img> tag:", e);
//     showNotification("Failed to display image", "error");
//   };

//   const handleZoomIn = () => {
//     setScale((prev) => Math.min(prev + 0.25, 5));
//   };

//   const handleZoomOut = () => {
//     setScale((prev) => Math.max(prev - 0.25, 0.5));
//   };

//   const handleResetZoom = () => {
//     setScale(1);
//     setPosition({ x: 0, y: 0 });
//   };

//   const handleBrightnessIncrease = () => {
//   setBrightness((prev) => Math.min(prev + 10, 200));
// };

// const handleBrightnessDecrease = () => {
//   setBrightness((prev) => Math.max(prev - 10, 0));
// };

// const handleResetBrightness = () => {
//   setBrightness(100);
// };

//   const toggleHighRes = () => {
//     if (isImageLoading) {
//       console.log("Already loading, ignoring toggle");
//       return;
//     }

//     const newHighRes = !isHighRes;
//     console.log(`Toggling resolution: ${isHighRes ? 'high' : 'low'} → ${newHighRes ? 'high' : 'low'}`);
    
//     setIsHighRes(newHighRes);
    
//     if (selectedImage) {
//       showNotification(
//         newHighRes ? "Switching to high res..." : "Switching to low res...",
//         "success"
//       );
      
//       loadImage(selectedImage, newHighRes);
//     }
//   };

//   const handleMouseDown = (e) => {
//     if (scale > 1) {
//       setIsDragging(true);
//       setDragStart({
//         x: e.clientX - position.x,
//         y: e.clientY - position.y,
//       });
//     }
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging) {
//       setPosition({
//         x: e.clientX - dragStart.x,
//         y: e.clientY - dragStart.y,
//       });
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   const handlePreviousImage = () => {
//     if (currentImageIndex > 0 && onNavigatePrevious) {
//       onNavigatePrevious();
//     }
//   };

//   const handleNextImage = () => {
//     if (currentImageIndex < filteredImages.length - 1 && onNavigateNext) {
//       onNavigateNext();
//     }
//   };

// // Keyboard shortcuts
// // Keyboard shortcuts
// useEffect(() => {
//   const handleKeyDown = (e) => {
//     // Prevent shortcuts if user is typing in an input field
//     const isTyping = ['INPUT', 'TEXTAREA'].includes(e.target.tagName);
    
//     if (isTyping) {
//       return; // Don't trigger shortcuts when typing
//     }

//     // Navigation shortcuts (without Ctrl)
//     if (e.key === "ArrowLeft") {
//       e.preventDefault();
//       handlePreviousImage();
//     } else if (e.key === "ArrowRight") {
//       e.preventDefault();
//       handleNextImage();
//     } 
//     // Zoom shortcuts (without Ctrl)
//     else if (e.key === "+" || e.key === "=") {
//       e.preventDefault();
//       handleZoomIn();
//     } else if (e.key === "-") {
//       e.preventDefault();
//       handleZoomOut();
//     }
//     // Brightness shortcuts using < and > (or , and .)
//     else if (e.key === "," || e.key === "<") {
//       e.preventDefault();
//       handleBrightnessDecrease();
//     } else if (e.key === "." || e.key === ">") {
//       e.preventDefault();
//       handleBrightnessIncrease();
//     } 
//     // Reset brightness with B key
//     else if (e.key === "b" || e.key === "B") {
//       e.preventDefault();
//       handleResetBrightness();
//     }
//     // Reset zoom (keeping Ctrl for this one to avoid accidental resets)
//     else if ((e.ctrlKey || e.metaKey) && e.key === "0") {
//       e.preventDefault();
//       handleResetZoom();
//     } 
//     // Toggle high-res with 'h' key (without Ctrl)
//     else if (e.key === "h" || e.key === "H") {
//       e.preventDefault();
//       toggleHighRes();
//     }
//   };

//   window.addEventListener("keydown", handleKeyDown);
//   return () => window.removeEventListener("keydown", handleKeyDown);
// }, [isHighRes, isImageLoading, currentImageIndex, filteredImages, brightness]);

//   return (
//     <div
//       className={`flex-1 p-6 overflow-hidden flex flex-col transition-all duration-300 ${
//         isSidebarCollapsed ? "ml-0" : ""
//       }`}
//     >
//       {selectedImage ? (
//         <div className="bg-white rounded-lg shadow-lg p-6 flex flex-col h-full">
//           <div className="flex justify-between items-center mb-4">
//             <h2 className="text-xl font-semibold truncate mr-4">
//               {selectedImage}
//             </h2>
//             <div className="flex items-center gap-3">
//               <div className="text-sm text-gray-600 whitespace-nowrap">
//                 Image {currentImageIndex + 1} of {filteredImages.length}
//               </div>
//             </div>
//           </div>

// {/* Controls */}
// <div className="flex justify-between items-center mb-4 gap-4">
//   {/* Zoom Controls */}
//   <div className="flex items-center gap-2">
//     <button
//       onClick={handleZoomOut}
//       disabled={scale <= 0.5}
//       className={`p-2 rounded ${
//         scale <= 0.5
//           ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//           : "bg-blue-500 text-white hover:bg-blue-600"
//       }`}
//       title="Zoom Out (-)"
//     >
//       <ZoomOut className="w-5 h-5" />
//     </button>
//     <span className="text-sm font-medium min-w-[60px] text-center">
//       {Math.round(scale * 100)}%
//     </span>
//     <button
//       onClick={handleZoomIn}
//       disabled={scale >= 5}
//       className={`p-2 rounded ${
//         scale >= 5
//           ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//           : "bg-blue-500 text-white hover:bg-blue-600"
//       }`}
//       title="Zoom In (+)"
//     >
//       <ZoomIn className="w-5 h-5" />
//     </button>
//     <button
//       onClick={handleResetZoom}
//       className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600"
//       title="Reset Zoom (Ctrl+0)"
//     >
//       <Maximize2 className="w-5 h-5" />
//     </button>
//   </div>

// {/* Brightness Controls */}
// <div className="flex items-center gap-2">
//   <button
//     onClick={handleBrightnessDecrease}
//     disabled={brightness <= 0}
//     className={`p-2 rounded ${
//       brightness <= 0
//         ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//         : "bg-orange-500 text-white hover:bg-orange-600"
//     }`}
//     title="Decrease Brightness (< or ,)"
//   >
//     <Moon className="w-5 h-5" />
//   </button>
//   <span className="text-sm font-medium min-w-[60px] text-center">
//     {brightness}%
//   </span>
//   <button
//     onClick={handleBrightnessIncrease}
//     disabled={brightness >= 200}
//     className={`p-2 rounded ${
//       brightness >= 200
//         ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//         : "bg-yellow-500 text-white hover:bg-yellow-600"
//     }`}
//     title="Increase Brightness (> or .)"
//   >
//     <Sun className="w-5 h-5" />
//   </button>
//   <button
//   onClick={handleResetBrightness}
//   className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600"
//   title="Reset Brightness (B)"
// >
//   <Maximize2 className="w-5 h-5" />
// </button>
// </div>


//             {/* Quality Toggle */}
//             <div className="flex items-center gap-2 bg-gray-100 rounded-lg p-1">
//               <button
//                 onClick={toggleHighRes}
//                 disabled={isImageLoading}
//                 className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all duration-200 ${
//                   isImageLoading
//                     ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                     : !isHighRes
//                     ? "bg-white text-blue-600 shadow-sm"
//                     : "text-gray-600 hover:text-gray-800"
//                 }`}
//                 title="Low Res - Lower quality, faster loading (Ctrl+H)"
//               >
//                 <Zap className="w-4 h-4" />
//                 <span className="text-sm">Low-res</span>
//               </button>
              
//               <button
//                 onClick={toggleHighRes}
//                 disabled={isImageLoading}
//                 className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium transition-all duration-200 ${
//                   isImageLoading
//                     ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                     : isHighRes
//                     ? "bg-white text-purple-600 shadow-sm"
//                     : "text-gray-600 hover:text-gray-800"
//                 }`}
//                 title="High Res  - Full resolution, slower loading (Ctrl+H)"
//               >
//                 <Sparkles className="w-4 h-4" />
//                 <span className="text-sm">High-res</span>
//               </button>
//             </div>

//             {/* Navigation Controls */}
//             <div className="flex items-center gap-2">
//            <button
//   onClick={handlePreviousImage}
//   disabled={currentImageIndex === 0}
//   className={`flex items-center gap-2 px-4 py-2 rounded ${
//     currentImageIndex === 0
//       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//       : "bg-blue-500 text-white hover:bg-blue-600"
//   }`}
//   title="Previous Image (←)"
// >
//   <ArrowLeft className="w-4 h-4" />
//   Previous
// </button>

// <button
//   onClick={handleNextImage}
//   disabled={currentImageIndex === filteredImages.length - 1}
//   className={`flex items-center gap-2 px-4 py-2 rounded ${
//     currentImageIndex === filteredImages.length - 1
//       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//       : "bg-blue-500 text-white hover:bg-blue-600"
//   }`}
//   title="Next Image (→)"
// >
//   Next
//   <ArrowRight className="w-4 h-4" />
// </button>
//             </div>
//           </div>

//           {/* Image Container */}
//           <div
//             ref={containerRef}
//             className="relative flex-1 overflow-hidden bg-gray-50 rounded border border-gray-200"
//             onMouseDown={handleMouseDown}
//             onMouseMove={handleMouseMove}
//             onMouseUp={handleMouseUp}
//             onMouseLeave={handleMouseUp}
//             style={{
//               cursor: isDragging
//                 ? "grabbing"
//                 : scale > 1
//                 ? "grab"
//                 : "default",
//             }}
//           >
//             {isImageLoading ? (
//               <div className="flex items-center justify-center h-full">
//                 <div className="text-center">
//                   <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-2"></div>
//                   <p className="text-sm text-gray-600">
//                     Loading {isHighRes ? "High Res" : "Low Res"} mode...
//                   </p>
//                 </div>
//               </div>
//             ) : imageUrl ? (
//               <div className="w-full h-full flex items-center justify-center overflow-hidden">
//                <img
//                 ref={imageRef}
//                 src={imageUrl}
//                 alt={selectedImage}
//                 className="max-w-none"
//                 onLoad={handleImageLoad}
//                 onError={handleImageError}
//                 style={{
//                     transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
//                     filter: `brightness(${brightness}%)`,
//                     transition: isDragging
//                     ? "none"
//                     : "transform 0.2s ease-out, filter 0.2s ease-out",
//                     maxHeight: "100%",
//                     maxWidth: scale === 1 ? "100%" : "none",
//                     objectFit: "contain",
//                 }}
//                 draggable={false}
//                 />
//               </div>
//             ) : (
//               <div className="flex items-center justify-center h-full">
//                 <p className="text-gray-500">No image loaded</p>
//               </div>
//             )}
//           </div>

// {/* Helper Text */}
// <div className="mt-4 text-center text-sm text-gray-500">
//   <span className="font-medium"></span>
//   {" • "}
//   Use ← / → to navigate
//   {" • "}
//   + / - to zoom
//   {" • "}
//   &lt; / &gt; (or , / .) for brightness
//   {" • "}
//   B to reset brightness
//   {" • "}
//   H to toggle mode
//   {scale > 1 && " • Drag to pan"}
// </div>
//         </div>
//       ) : (
//         <div className="flex items-center justify-center h-full bg-white rounded-lg shadow-lg">
//           <p className="text-gray-500 text-lg">
//             {isListLoading
//               ? "Loading images..."
//               : "No images available in this batch"}
//           </p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ImageDisplay;

// import React, { useState, useRef, useEffect } from "react";
// import {
//   ArrowLeft,
//   ArrowRight,
//   ZoomIn,
//   ZoomOut,
//   Maximize2,
//   Sparkles,
//   Zap,
//   Sun,
//   Moon,
// } from "lucide-react";

// const ImageDisplay = ({
//   isSidebarCollapsed,
//   selectedImage,
//   imageUrl,
//   setImageUrl,
//   isImageLoading,
//   isHighRes,
//   setIsHighRes,
//   filteredImages,
//   currentImageIndex,
//   loadImage,
//   showNotification,
//   isListLoading,
//   onNavigatePrevious,
//   onNavigateNext,
// }) => {
//   const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
//   const [scale, setScale] = useState(1);
//   const [position, setPosition] = useState({ x: 0, y: 0 });
//   const [isDragging, setIsDragging] = useState(false);
//   const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
//   const [brightness, setBrightness] = useState(100);

//   const imageRef = useRef(null);
//   const containerRef = useRef(null);


// // Reset zoom, position, and brightness when image URL changes
// useEffect(() => {
//   setScale(1);
//   setPosition({ x: 0, y: 0 });
//   setBrightness(100);
// }, [imageUrl]);

//   const handleImageLoad = (e) => {
//     const img = e.target;
//     setImageSize({
//       width: img.naturalWidth,
//       height: img.naturalHeight,
//     });
//     console.log("Image loaded successfully:", img.naturalWidth, "x", img.naturalHeight);
//   };

//   const handleImageError = (e) => {
//     console.error("Image failed to load in <img> tag:", e);
//     showNotification("Failed to display image", "error");
//   };

//   const handleZoomIn = () => {
//     setScale((prev) => Math.min(prev + 0.25, 5));
//   };

//   const handleZoomOut = () => {
//     setScale((prev) => Math.max(prev - 0.25, 0.5));
//   };

//   const handleResetZoom = () => {
//     setScale(1);
//     setPosition({ x: 0, y: 0 });
//   };

//   const handleBrightnessIncrease = () => {
//   setBrightness((prev) => Math.min(prev + 10, 200));
// };

// const handleBrightnessDecrease = () => {
//   setBrightness((prev) => Math.max(prev - 10, 0));
// };

// const handleResetBrightness = () => {
//   setBrightness(100);
// };

//   const toggleHighRes = () => {
//     if (isImageLoading) {
//       console.log("Already loading, ignoring toggle");
//       return;
//     }

//     const newHighRes = !isHighRes;
//     console.log(`Toggling resolution: ${isHighRes ? 'high' : 'low'} → ${newHighRes ? 'high' : 'low'}`);
    
//     setIsHighRes(newHighRes);
    
//     if (selectedImage) {
//       showNotification(
//         newHighRes ? "Switching to high res..." : "Switching to low res...",
//         "success"
//       );
      
//       loadImage(selectedImage, newHighRes);
//     }
//   };

//   const handleMouseDown = (e) => {
//     if (scale > 1) {
//       setIsDragging(true);
//       setDragStart({
//         x: e.clientX - position.x,
//         y: e.clientY - position.y,
//       });
//     }
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging) {
//       setPosition({
//         x: e.clientX - dragStart.x,
//         y: e.clientY - dragStart.y,
//       });
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   const handlePreviousImage = () => {
//     if (currentImageIndex > 0 && onNavigatePrevious) {
//       onNavigatePrevious();
//     }
//   };

//   const handleNextImage = () => {
//     if (currentImageIndex < filteredImages.length - 1 && onNavigateNext) {
//       onNavigateNext();
//     }
//   };

// // Keyboard shortcuts
// // Keyboard shortcuts
// useEffect(() => {
//   const handleKeyDown = (e) => {
//     // Prevent shortcuts if user is typing in an input field
//     const isTyping = ['INPUT', 'TEXTAREA'].includes(e.target.tagName);
    
//     if (isTyping) {
//       return; // Don't trigger shortcuts when typing
//     }

//     // Numpad navigation for panning (50px movement per keypress)
//     const panStep = 50;
//     if (e.key === "4" || e.key === "ArrowLeft") {
//       if (e.key === "4") {
//         // Numpad 4 - Pan LEFT (move image right, so increase x)
//         e.preventDefault();
//         setPosition(prev => ({ ...prev, x: prev.x + panStep }));
//       } else {
//         // Arrow Left - Navigate to previous image
//         e.preventDefault();
//         handlePreviousImage();
//       }
//     } else if (e.key === "6" || e.key === "ArrowRight") {
//       if (e.key === "6") {
//         // Numpad 6 - Pan RIGHT (move image left, so decrease x)
//         e.preventDefault();
//         setPosition(prev => ({ ...prev, x: prev.x - panStep }));
//       } else {
//         // Arrow Right - Navigate to next image
//         e.preventDefault();
//         handleNextImage();
//       }
//     } else if (e.key === "8") {
//       // Numpad 8 - Pan UP (move image down, so increase y)
//       e.preventDefault();
//       setPosition(prev => ({ ...prev, y: prev.y + panStep }));
//     } else if (e.key === "2") {
//       // Numpad 2 - Pan DOWN (move image up, so decrease y)
//       e.preventDefault();
//       setPosition(prev => ({ ...prev, y: prev.y - panStep }));
//     } else if (e.key === "5") {
//       // Numpad 5 - Recenter position only (without changing zoom)
//       e.preventDefault();
//       setPosition({ x: 0, y: 0 });
//     }
//     // Zoom shortcuts (without Ctrl)
//     else if (e.key === "+" || e.key === "=") {
//       e.preventDefault();
//       handleZoomIn();
//     } else if (e.key === "-") {
//       e.preventDefault();
//       handleZoomOut();
//     }
//     // Brightness shortcuts using < and > (or , and .)
//     else if (e.key === "," || e.key === "<") {
//       e.preventDefault();
//       handleBrightnessDecrease();
//     } else if (e.key === "." || e.key === ">") {
//       e.preventDefault();
//       handleBrightnessIncrease();
//     } 
//     // Reset brightness with B key
//     else if (e.key === "b" || e.key === "B") {
//       e.preventDefault();
//       handleResetBrightness();
//     }
//     // Reset zoom AND recenter with Ctrl+0
//     else if ((e.ctrlKey || e.metaKey) && e.key === "0") {
//       e.preventDefault();
//       setScale(1);
//       setPosition({ x: 0, y: 0 });
//     } 
//     // Toggle high-res with 'h' key (without Ctrl)
//     else if (e.key === "h" || e.key === "H") {
//       e.preventDefault();
//       toggleHighRes();
//     }
//   };

//   window.addEventListener("keydown", handleKeyDown);
//   return () => window.removeEventListener("keydown", handleKeyDown);
// }, [isHighRes, isImageLoading, currentImageIndex, filteredImages, brightness]);

//   return (
//     <div
//       className={`flex-1 p-3 overflow-hidden flex flex-col transition-all duration-300 ${
//         isSidebarCollapsed ? "ml-0" : ""
//       }`}
//     >
//       {selectedImage ? (
//         <div className="bg-white rounded-lg shadow-lg p-3 flex flex-col h-full">
//           {/* Compact header with all controls on one line */}
//           <div className="flex justify-between items-center mb-2 gap-2 flex-wrap">
//             {/* Left side: Image name and counter */}
//             <div className="flex items-center gap-3 min-w-0 flex-shrink">
//               <h2 className="text-base font-semibold truncate">
//                 {selectedImage}
//               </h2>
//               <span className="text-xs text-gray-600 whitespace-nowrap">
//                 {currentImageIndex + 1}/{filteredImages.length}
//               </span>
//             </div>

//             {/* Right side: All controls in compact form */}
//             <div className="flex items-center gap-2 flex-wrap">
//               {/* Zoom Controls */}
//               <div className="flex items-center gap-1">
//                 <button
//                   onClick={handleZoomOut}
//                   disabled={scale <= 0.5}
//                   className={`p-1.5 rounded ${
//                     scale <= 0.5
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Zoom Out (-)"
//                 >
//                   <ZoomOut className="w-4 h-4" />
//                 </button>
//                 <span className="text-xs font-medium min-w-[45px] text-center">
//                   {Math.round(scale * 100)}%
//                 </span>
//                 <button
//                   onClick={handleZoomIn}
//                   disabled={scale >= 5}
//                   className={`p-1.5 rounded ${
//                     scale >= 5
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Zoom In (+)"
//                 >
//                   <ZoomIn className="w-4 h-4" />
//                 </button>
//                 <button
//                   onClick={handleResetZoom}
//                   className="p-1.5 bg-gray-500 text-white rounded hover:bg-gray-600"
//                   title="Reset Zoom (Ctrl+0)"
//                 >
//                   <Maximize2 className="w-4 h-4" />
//                 </button>
//               </div>

//               {/* Brightness Controls */}
//               <div className="flex items-center gap-1">
//                 <button
//                   onClick={handleBrightnessDecrease}
//                   disabled={brightness <= 0}
//                   className={`p-1.5 rounded ${
//                     brightness <= 0
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-orange-500 text-white hover:bg-orange-600"
//                   }`}
//                   title="Decrease Brightness (< or ,)"
//                 >
//                   <Moon className="w-4 h-4" />
//                 </button>
//                 <span className="text-xs font-medium min-w-[45px] text-center">
//                   {brightness}%
//                 </span>
//                 <button
//                   onClick={handleBrightnessIncrease}
//                   disabled={brightness >= 200}
//                   className={`p-1.5 rounded ${
//                     brightness >= 200
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-yellow-500 text-white hover:bg-yellow-600"
//                   }`}
//                   title="Increase Brightness (> or .)"
//                 >
//                   <Sun className="w-4 h-4" />
//                 </button>
//                 <button
//                   onClick={handleResetBrightness}
//                   className="p-1.5 bg-gray-500 text-white rounded hover:bg-gray-600"
//                   title="Reset Brightness (B)"
//                 >
//                   <Maximize2 className="w-4 h-4" />
//                 </button>
//               </div>

//               {/* Quality Toggle */}
//               <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5">
//                 <button
//                   onClick={toggleHighRes}
//                   disabled={isImageLoading}
//                   className={`flex items-center gap-1 px-2 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
//                     isImageLoading
//                       ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                       : !isHighRes
//                       ? "bg-white text-blue-600 shadow-sm"
//                       : "text-gray-600 hover:text-gray-800"
//                   }`}
//                   title="Low Res - Lower quality, faster loading (H)"
//                 >
//                   <Zap className="w-3.5 h-3.5" />
//                   <span>Low</span>
//                 </button>
                
//                 <button
//                   onClick={toggleHighRes}
//                   disabled={isImageLoading}
//                   className={`flex items-center gap-1 px-2 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
//                     isImageLoading
//                       ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                       : isHighRes
//                       ? "bg-white text-purple-600 shadow-sm"
//                       : "text-gray-600 hover:text-gray-800"
//                   }`}
//                   title="High Res - Full resolution, slower loading (H)"
//                 >
//                   <Sparkles className="w-3.5 h-3.5" />
//                   <span>High</span>
//                 </button>
//               </div>

//               {/* Navigation Controls */}
//               <div className="flex items-center gap-1">
//                 <button
//                   onClick={handlePreviousImage}
//                   disabled={currentImageIndex === 0}
//                   className={`flex items-center gap-1 px-2 py-1.5 rounded text-xs ${
//                     currentImageIndex === 0
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Previous Image (←)"
//                 >
//                   <ArrowLeft className="w-3.5 h-3.5" />
//                   <span>Prev</span>
//                 </button>

//                 <button
//                   onClick={handleNextImage}
//                   disabled={currentImageIndex === filteredImages.length - 1}
//                   className={`flex items-center gap-1 px-2 py-1.5 rounded text-xs ${
//                     currentImageIndex === filteredImages.length - 1
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-blue-500 text-white hover:bg-blue-600"
//                   }`}
//                   title="Next Image (→)"
//                 >
//                   <span>Next</span>
//                   <ArrowRight className="w-3.5 h-3.5" />
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Image Container */}
//           <div
//             ref={containerRef}
//             className="relative flex-1 overflow-hidden bg-gray-50 rounded border border-gray-200"
//             onMouseDown={handleMouseDown}
//             onMouseMove={handleMouseMove}
//             onMouseUp={handleMouseUp}
//             onMouseLeave={handleMouseUp}
//             style={{
//               cursor: isDragging
//                 ? "grabbing"
//                 : scale > 1
//                 ? "grab"
//                 : "default",
//             }}
//           >
//             {isImageLoading ? (
//               <div className="flex items-center justify-center h-full">
//                 <div className="text-center">
//                   <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-2"></div>
//                   <p className="text-sm text-gray-600">
//                     Loading {isHighRes ? "High Res" : "Low Res"} mode...
//                   </p>
//                 </div>
//               </div>
//             ) : imageUrl ? (
//               <div className="w-full h-full flex items-center justify-center overflow-hidden">
//                 <img
//                   ref={imageRef}
//                   src={imageUrl}
//                   alt={selectedImage}
//                   className="max-w-full max-h-full"
//                   onLoad={handleImageLoad}
//                   onError={handleImageError}
//                   style={{
//                     transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
//                     filter: `brightness(${brightness}%)`,
//                     transition: isDragging
//                       ? "none"
//                       : "transform 0.2s ease-out, filter 0.2s ease-out",
//                     objectFit: "contain",
//                   }}
//                   draggable={false}
//                 />
//               </div>
//             ) : (
//               <div className="flex items-center justify-center h-full">
//                 <p className="text-gray-500">No image loaded</p>
//               </div>
//             )}
//           </div>
//         </div>
//       ) : (
//         <div className="flex items-center justify-center h-full bg-white rounded-lg shadow-lg">
//           <p className="text-gray-500 text-lg">
//             {isListLoading
//               ? "Loading images..."
//               : "No images available in this batch"}
//           </p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ImageDisplay;


import React, { useState, useRef, useEffect } from "react";
import {
  ArrowLeft,
  ArrowRight,
  ZoomIn,
  ZoomOut,
  Maximize2,
  Sparkles,
  Zap,
  Sun,
  Moon,
} from "lucide-react";

const ImageDisplay = ({
  isSidebarCollapsed,
  selectedImage,
  imageUrl,
  setImageUrl,
  isImageLoading,
  isHighRes,
  setIsHighRes,
  filteredImages,
  currentImageIndex,
  loadImage,
  showNotification,
  isListLoading,
  onNavigatePrevious,
  onNavigateNext,
}) => {
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [brightness, setBrightness] = useState(100);

  const imageRef = useRef(null);
  const containerRef = useRef(null);


// Reset zoom, position, and brightness when image URL changes
useEffect(() => {
  setScale(1);
  setPosition({ x: 0, y: 0 });
  setBrightness(100);
}, [imageUrl]);

  const handleImageLoad = (e) => {
    const img = e.target;
    setImageSize({
      width: img.naturalWidth,
      height: img.naturalHeight,
    });
    console.log("Image loaded successfully:", img.naturalWidth, "x", img.naturalHeight);
  };

  const handleImageError = (e) => {
    console.error("Image failed to load in <img> tag:", e);
    showNotification("Failed to display image", "error");
  };

  const handleZoomIn = () => {
    setScale((prev) => Math.min(prev + 0.25, 5));
  };

  const handleZoomOut = () => {
    setScale((prev) => Math.max(prev - 0.25, 0.5));
  };

  const handleResetZoom = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  };

  const handleBrightnessIncrease = () => {
  setBrightness((prev) => Math.min(prev + 10, 200));
};

const handleBrightnessDecrease = () => {
  setBrightness((prev) => Math.max(prev - 10, 0));
};

const handleResetBrightness = () => {
  setBrightness(100);
};

  const toggleHighRes = () => {
    if (isImageLoading) {
      console.log("Already loading, ignoring toggle");
      return;
    }

    const newHighRes = !isHighRes;
    console.log(`Toggling resolution: ${isHighRes ? 'high' : 'low'} → ${newHighRes ? 'high' : 'low'}`);
    
    setIsHighRes(newHighRes);
    
    if (selectedImage) {
      showNotification(
        newHighRes ? "Switching to high res..." : "Switching to low res...",
        "success"
      );
      
      loadImage(selectedImage, newHighRes);
    }
  };

  const handleMouseDown = (e) => {
    if (scale > 1) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - position.x,
        y: e.clientY - position.y,
      });
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handlePreviousImage = () => {
    if (currentImageIndex > 0 && onNavigatePrevious) {
      onNavigatePrevious();
    }
  };

  const handleNextImage = () => {
    if (currentImageIndex < filteredImages.length - 1 && onNavigateNext) {
      onNavigateNext();
    }
  };

// Keyboard shortcuts
// Keyboard shortcuts
useEffect(() => {
  const handleKeyDown = (e) => {
    // Prevent shortcuts if user is typing in an input field
    const isTyping = ['INPUT', 'TEXTAREA'].includes(e.target.tagName);
    
    if (isTyping) {
      return; // Don't trigger shortcuts when typing
    }

    // Numpad navigation for panning (50px movement per keypress)
    const panStep = 50;
    if (e.key === "4" || e.key === "ArrowLeft") {
      if (e.key === "4") {
        // Numpad 4 - Pan LEFT (move image right, so increase x)
        e.preventDefault();
        setPosition(prev => ({ ...prev, x: prev.x + panStep }));
      } else {
        // Arrow Left - Navigate to previous image
        e.preventDefault();
        handlePreviousImage();
      }
    } else if (e.key === "6" || e.key === "ArrowRight") {
      if (e.key === "6") {
        // Numpad 6 - Pan RIGHT (move image left, so decrease x)
        e.preventDefault();
        setPosition(prev => ({ ...prev, x: prev.x - panStep }));
      } else {
        // Arrow Right - Navigate to next image
        e.preventDefault();
        handleNextImage();
      }
    } else if (e.key === "8") {
      // Numpad 8 - Pan UP (move image down, so increase y)
      e.preventDefault();
      setPosition(prev => ({ ...prev, y: prev.y + panStep }));
    } else if (e.key === "2") {
      // Numpad 2 - Pan DOWN (move image up, so decrease y)
      e.preventDefault();
      setPosition(prev => ({ ...prev, y: prev.y - panStep }));
    } else if (e.key === "5") {
      // Numpad 5 - Recenter position only (without changing zoom)
      e.preventDefault();
      setPosition({ x: 0, y: 0 });
    }
    // Zoom shortcuts (without Ctrl)
    else if (e.key === "+" || e.key === "=") {
      e.preventDefault();
      handleZoomIn();
    } else if (e.key === "-") {
      e.preventDefault();
      handleZoomOut();
    }
    // Brightness shortcuts using < and > (or , and .)
    else if (e.key === "," || e.key === "<") {
      e.preventDefault();
      handleBrightnessDecrease();
    } else if (e.key === "." || e.key === ">") {
      e.preventDefault();
      handleBrightnessIncrease();
    } 
    // Reset brightness with B key
    else if (e.key === "b" || e.key === "B") {
      e.preventDefault();
      handleResetBrightness();
    }
    // Reset zoom AND recenter with Ctrl+0
    else if ((e.ctrlKey || e.metaKey) && e.key === "0") {
      e.preventDefault();
      setScale(1);
      setPosition({ x: 0, y: 0 });
    } 
    // Toggle high-res with 'h' key (without Ctrl)
    else if (e.key === "h" || e.key === "H") {
      e.preventDefault();
      toggleHighRes();
    }
  };

  window.addEventListener("keydown", handleKeyDown);
  return () => window.removeEventListener("keydown", handleKeyDown);
}, [isHighRes, isImageLoading, currentImageIndex, filteredImages, brightness]);

  return (
    <div
      className={`flex-1 p-3 overflow-hidden flex flex-col transition-all duration-300 ${
        isSidebarCollapsed ? "ml-0" : ""
      }`}
    >
      {selectedImage ? (
        <div className="bg-white rounded-lg shadow-lg p-3 flex flex-col h-full">
          {/* Compact header with all controls on one line */}
          <div className="flex justify-between items-center mb-2 gap-2 flex-wrap">
            {/* Left side: Image name and counter */}
            <div className="flex items-center gap-3 min-w-0 flex-shrink">
              <h2 className="text-base font-semibold truncate">
                {selectedImage}
              </h2>
              <span className="text-xs text-gray-600 whitespace-nowrap">
                {currentImageIndex + 1}/{filteredImages.length}
              </span>
            </div>

            {/* Right side: All controls in compact form */}
            <div className="flex items-center gap-2 flex-wrap">
              {/* Zoom Controls */}
              <div className="flex items-center gap-1">
                <button
                  onClick={handleZoomOut}
                  disabled={scale <= 0.5}
                  className={`p-1.5 rounded ${
                    scale <= 0.5
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-blue-500 text-white hover:bg-blue-600"
                  }`}
                  title="Zoom Out (-)"
                >
                  <ZoomOut className="w-4 h-4" />
                </button>
                <span className="text-xs font-medium min-w-[45px] text-center">
                  {Math.round(scale * 100)}%
                </span>
                <button
                  onClick={handleZoomIn}
                  disabled={scale >= 5}
                  className={`p-1.5 rounded ${
                    scale >= 5
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-blue-500 text-white hover:bg-blue-600"
                  }`}
                  title="Zoom In (+)"
                >
                  <ZoomIn className="w-4 h-4" />
                </button>
                <button
                  onClick={handleResetZoom}
                  className="p-1.5 bg-gray-500 text-white rounded hover:bg-gray-600"
                  title="Reset Zoom (Ctrl+0)"
                >
                  <Maximize2 className="w-4 h-4" />
                </button>
              </div>

              {/* Brightness Controls */}
              <div className="flex items-center gap-1">
                <button
                  onClick={handleBrightnessDecrease}
                  disabled={brightness <= 0}
                  className={`p-1.5 rounded ${
                    brightness <= 0
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-orange-500 text-white hover:bg-orange-600"
                  }`}
                  title="Decrease Brightness (< or ,)"
                >
                  <Moon className="w-4 h-4" />
                </button>
                <span className="text-xs font-medium min-w-[45px] text-center">
                  {brightness}%
                </span>
                <button
                  onClick={handleBrightnessIncrease}
                  disabled={brightness >= 200}
                  className={`p-1.5 rounded ${
                    brightness >= 200
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-yellow-500 text-white hover:bg-yellow-600"
                  }`}
                  title="Increase Brightness (> or .)"
                >
                  <Sun className="w-4 h-4" />
                </button>
                <button
                  onClick={handleResetBrightness}
                  className="p-1.5 bg-gray-500 text-white rounded hover:bg-gray-600"
                  title="Reset Brightness (B)"
                >
                  <Maximize2 className="w-4 h-4" />
                </button>
              </div>

              {/* Quality Toggle */}
              <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5">
                <button
                  onClick={toggleHighRes}
                  disabled={isImageLoading}
                  className={`flex items-center gap-1 px-2 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
                    isImageLoading
                      ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                      : !isHighRes
                      ? "bg-white text-blue-600 shadow-sm"
                      : "text-gray-600 hover:text-gray-800"
                  }`}
                  title="Low Res - Lower quality, faster loading (H)"
                >
                  <Zap className="w-3.5 h-3.5" />
                  <span>Low</span>
                </button>
                
                <button
                  onClick={toggleHighRes}
                  disabled={isImageLoading}
                  className={`flex items-center gap-1 px-2 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
                    isImageLoading
                      ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                      : isHighRes
                      ? "bg-white text-purple-600 shadow-sm"
                      : "text-gray-600 hover:text-gray-800"
                  }`}
                  title="High Res - Full resolution, slower loading (H)"
                >
                  <Sparkles className="w-3.5 h-3.5" />
                  <span>High</span>
                </button>
              </div>

              {/* Navigation Controls */}
              <div className="flex items-center gap-1">
                <button
                  onClick={handlePreviousImage}
                  disabled={currentImageIndex === 0}
                  className={`flex items-center gap-1 px-2 py-1.5 rounded text-xs ${
                    currentImageIndex === 0
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-blue-500 text-white hover:bg-blue-600"
                  }`}
                  title="Previous Image (←)"
                >
                  <ArrowLeft className="w-3.5 h-3.5" />
                  <span>Prev</span>
                </button>

                <button
                  onClick={handleNextImage}
                  disabled={currentImageIndex === filteredImages.length - 1}
                  className={`flex items-center gap-1 px-2 py-1.5 rounded text-xs ${
                    currentImageIndex === filteredImages.length - 1
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-blue-500 text-white hover:bg-blue-600"
                  }`}
                  title="Next Image (→)"
                >
                  <span>Next</span>
                  <ArrowRight className="w-3.5 h-3.5" />
                </button>
              </div>
            </div>
          </div>

          {/* Image Container */}
          <div
            ref={containerRef}
            className="relative flex-1 overflow-hidden bg-gray-50 rounded border border-gray-200"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            style={{
              cursor: isDragging
                ? "grabbing"
                : scale > 1
                ? "grab"
                : "default",
            }}
          >
            {isImageLoading ? (
              <div className="flex items-center justify-center h-full">
                <div className="text-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-2"></div>
                  <p className="text-sm text-gray-600">
                    Loading {isHighRes ? "High Res" : "Low Res"} mode...
                  </p>
                </div>
              </div>
            ) : imageUrl ? (
              <div className="w-full h-full flex items-center justify-center overflow-hidden">
                <img
                  ref={imageRef}
                  src={imageUrl}
                  alt={selectedImage}
                  className="max-w-full max-h-full"
                  onLoad={handleImageLoad}
                  onError={handleImageError}
                  style={{
                    transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
                    filter: `brightness(${brightness}%)`,
                    transition: isDragging
                      ? "none"
                      : "transform 0.2s ease-out, filter 0.2s ease-out",
                    objectFit: "contain",
                  }}
                  draggable={false}
                />
              </div>
            ) : (
              <div className="flex items-center justify-center h-full">
                <p className="text-gray-500">No image loaded</p>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center h-full bg-white rounded-lg shadow-lg">
          <p className="text-gray-500 text-lg">
            {isListLoading
              ? "Loading images..."
              : "No images available in this batch"}
          </p>
        </div>
      )}
    </div>
  );
};

export default ImageDisplay;